import { CrossFrameMessenger, VersionNumber } from '@tableau/api-internal-contract-js';
import { Instance } from '@tableau/preslayer-api-contract';
import { PresentationLayer } from '../common-bootstrap/NoOpPresentationLayer';
import { Disposable } from '../Disposable';
import { MessageHandler } from './MessageHandler';

export class EmbeddingApiDispatcher implements Disposable {
  private readonly _messageHandler: MessageHandler;

  public constructor(version: VersionNumber, presLayer: PresentationLayer = Instance, thisWindow: Window | null = window) {
    // There is no parent frame to talk to
    if (!thisWindow?.parent) {
      console.error('Failed to create EmbeddingApiDispatcher. No parent frame to talk to');
      return;
    }

    // TFS 1250035: Open security issue that we'll tackle later
    const messenger = new CrossFrameMessenger(thisWindow, thisWindow.parent, '*');
    this._messageHandler = new MessageHandler(messenger, presLayer, version);
  }

  public dispose(): void {
    this._messageHandler.dispose();
  }
}
